import { Form } from 'react-bootstrap';
import Button from '../UI/button';
import { useState, useEffect } from 'react';

type Props = {
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  fullWidth?: boolean;
};

const ThSearchForm = ({
  handleSubmit,
  placeholder = 'Search',
  value,
  onChange,
  fullWidth = false
}: Props) => {
  const [localValue, setLocalValue] = useState(value || '');

  // Sync with external value changes
  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  // Debounce the onChange callback
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onChange && localValue !== value) {
        onChange(localValue);
      }
    }, 300); // 300ms debounce delay

    return () => clearTimeout(timer);
  }, [localValue, onChange, value]);

  const handleLocalChange = (newValue: string) => {
    setLocalValue(newValue);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div
        className={`th-search-form-wrapper${fullWidth ? ' th-search-form-wrapper--full' : ''}`}
      >
        <Form.Control
          name='searchText'
          required
          type='text'
          placeholder={placeholder}
          value={localValue}
          onChange={(e) => handleLocalChange(e.target.value)}
          className='rounded-pill ps-3 pe-5'
        />
        <Button
          type='submit'
          variant='transparent'
          className='th-search-form-submit'
        >
          <svg
            width='14'
            height='14'
            viewBox='0 0 14 14'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g opacity='0.5'>
              <path
                fillRule='evenodd'
                d='M5.99231 10.9869C8.75002 10.9869 10.9856 8.75128 10.9856 5.99346C10.9856 3.23565 8.75002 1 5.99231 1C3.23459 1 0.999023 3.23565 0.999023 5.99346C0.999023 8.75128 3.23459 10.9869 5.99231 10.9869Z'
                stroke='#777777'
                strokeWidth='1.5'
                strokeLinejoin='round'
              />
              <path
                d='M9.86133 9.86142L12.9998 13'
                stroke='#777777'
                strokeWidth='1.5'
                strokeLinejoin='round'
              />
            </g>
          </svg>
        </Button>
      </div>
    </Form>
  );
};
export default ThSearchForm;
